import { makeBetterEnum } from './betterEnum';

export const WATERSHED_DOMAIN = 'watershedclimate.com';
export const WATERSHED_EMAIL_SUFFIX = `@${WATERSHED_DOMAIN}`;
export const WATERSHED_CONTRACTOR_EMAIL_SUFFIX = `-c${WATERSHED_EMAIL_SUFFIX}`;

// These orgs are the contractor equivalent of the Watershed Root org and are used to give contractors initial access to Watershed
export const CONTRACTOR_MANAGEMENT_ORG_IDS = [
  'org_2BM4xnwCjzuGuoEKHdzB', // Accenture CDAs
  'org_2EW4xi6xAaEQAr9Uu1Ss', // KPMG CDAs
];

export const LockedReason = makeBetterEnum('deletion', 'migration');

export type LockedReason = (typeof LockedReason)[keyof typeof LockedReason];

export const AIConsent = makeBetterEnum(
  'None',
  'NoUseOfAIOnCustomerDataWithoutNotification',
  'NoUseOfAIInWatershedGenerallyWithoutNotification',
  'NoTrainingAnyAIUsingCustomerData',
  'NoTrainingThirdPartyAIUsingCustomerData',
  'SecurityRequirementsIfAITurnedOn',
  'ComplyWithLawsAndOrBestPracticesToDevelopAI',
  'OtherSeeAdditionalNotes'
);

export type AIConsent = (typeof AIConsent)[keyof typeof AIConsent];

export const Region = {
  Eu: 'eu',
  Us: 'us',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Region = (typeof Region)[keyof typeof Region];

export const WatershedPlanLegacy = makeBetterEnum(
  'Lite',
  'NetZero',
  'NoPlan',
  'Pro',
  'Standard'
);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type WatershedPlanLegacy =
  (typeof WatershedPlanLegacy)[keyof typeof WatershedPlanLegacy];

export const WatershedPlan = makeBetterEnum(
  'Custom',
  'Enterprise',
  'Essential',
  'Finance',
  'None',
  'Other',
  'PortcoPackage',
  'Premium',
  'Standard'
);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type WatershedPlan = (typeof WatershedPlan)[keyof typeof WatershedPlan];
